export default __webpack_public_path__ + "static/media/22195408_203712626835191_5474277315401064578_n.12a1774f.png";